import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

/**
 * Modal de busca de contas (equivalente a UBuscaContas).
 * Exclui tipos '6' e '8'.
 */
const ModalBuscaContas = ({ aberto, codigoGrupoEmpresa, onSelect, onFechar }) => {
  const [busca, setBusca] = useState('');
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (aberto) {
      setBusca('');
      setResultados([]);
    }
  }, [aberto]);

  const handleBuscar = async () => {
    // W-0488 fix freeze: exige termo de busca (>=2 caracteres) antes de consultar.
    // Sem termo, LookupContas retorna a lista inteira de contas do GE (potencialmente
    // centenas de milhares de linhas) -> renderizar tudo travava a tela.
    const termo = busca ? busca.trim() : '';
    if (termo.length < 2) {
      toast.warn('Digite ao menos 2 caracteres para buscar a conta.');
      return;
    }
    setLoading(true);
    try {
      const resp = await api.consultaOcorrenciasContasLookupContas({
        codigoGrupoEmpresa: codigoGrupoEmpresa || undefined,
        busca: termo,
      });
      setResultados(Array.isArray(resp) ? resp : []);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao buscar contas';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={aberto} onHide={onFechar} size="lg" centered>
      <Modal.Header style={{ background: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: 16 }}>Buscar Conta</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex mb-3" style={{ gap: 8 }}>
          <InputGroup size="sm">
            <InputGroup.Prepend>
              <InputGroup.Text><FaSearch /></InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              placeholder="Nome, apelido ou código..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleBuscar(); }}
            />
          </InputGroup>
          <Button size="sm" variant="primary" onClick={handleBuscar} disabled={loading}>
            Buscar
          </Button>
        </div>
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          <Table striped bordered hover size="sm" style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th>Código</th>
                <th>Apelido/Nome</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {resultados.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    {loading ? 'Buscando...' : 'Nenhum resultado'}
                  </td>
                </tr>
              ) : (
                resultados.map((c) => (
                  <tr
                    key={`${c.codigo_conta}-${c.codigo_grupo_empresa}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onSelect(c)}
                    onDoubleClick={() => onSelect(c)}
                  >
                    <td>{c.codigo_conta}</td>
                    <td>{c.apelido_conta}</td>
                    <td>{c.tipo}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onFechar}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalBuscaContas;
